import { render, staticRenderFns } from "./ToolsBar.vue?vue&type=template&id=4c99010f&scoped=true&"
import script from "./ToolsBar.vue?vue&type=script&lang=js&"
export * from "./ToolsBar.vue?vue&type=script&lang=js&"
import style0 from "./ToolsBar.vue?vue&type=style&index=0&id=4c99010f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99010f",
  null
  
)

export default component.exports